(ns app.strive-forms.question-fields.legal-statement
  (:require [app.strive-forms.component-multi-methods :refer [show-action-btn?]]
            [app.strive-forms.events :as events]
            [app.strive-forms.styles :refer [boolean-field-component-style
                                             radio-dot-button-style]]
            [re-com.core :as re-com :refer [at v-box]]
            [re-com.radio-button :refer [radio-button]]
            [re-frame.core :as re-frame]
            [reagent.core :as r]))


(defn legal-statement-button [{:keys [action label value answer-color model buttons-color]}]
  [:div
   {:class (boolean-field-component-style {:background-color answer-color :buttons-color buttons-color})}
   [radio-button :src (at)
    :label label
    :value value
    :model model
    :class (radio-dot-button-style)
    :on-change   action]])

(defn disapproved-messages-to-user [{:keys [message]}]
  [:div { ;:class (warning-notification)
         :style {:width "300px"}} message])


(defn- action-approve-btn [{:keys [input-data field-id text-val current-page index  btn-color regenerate-display-fields on-submit not-approved? disapprove-message]}]
  #(do
     (re-frame/dispatch [::events/update-input-local {:input-data input-data :key (keyword field-id) :value %}])
     (reset! current-page (+ 1 index))
     (reset! text-val %)
     (regenerate-display-fields
      (update input-data (keyword field-id) (fn [value]
                                              (assoc value :value @text-val))))
     (when (= (+ 1 index) (- (count input-data) 1))
       (on-submit))))

(defn- action-disapprove-btn [text-val  disapprove-btn-color]
  #(do
     (reset! text-val %)))

(defmethod show-action-btn? "legal_statement" [_]
  false)

(defn legal-statement-field [{:keys [field field-id index selected-language theme-data form-messages current-page input-data on-submit regenerate-display-fields hidden-fields display-fields]}]
  (let [text-val (r/atom (:value (get input-data (keyword field-id))))
        approve-btn-text (:legal_approve_btn_text form-messages)
        approve-btn-color (:approve_color (:additional_settings field))
        disapprove-btn-color (:not_approve_color (:additional_settings field))
        disapprove-btn-text (:legal_disapprove_btn_text form-messages)
        disapprove-message (:legal_approve_text form-messages)
        buttons-color (:buttons_color theme-data)]
    (fn [{:keys [field field-id index selected-language theme-data form-messages current-page input-data hidden-fields display-fields]}]
      [v-box
       :justify :center
       :align :center
       :children [[legal-statement-button {:label approve-btn-text
                                           :value approve-btn-text
                                           :answer-color  approve-btn-color
                                           :model text-val
                                           :buttons-color buttons-color
                                           :action (action-approve-btn {:input-data input-data :field-id field-id :text-val text-val :current-page current-page :index index  :btn-color approve-btn-color :regenerate-display-fields regenerate-display-fields :on-submit on-submit})}]
                  [legal-statement-button {:label disapprove-btn-text
                                           :value disapprove-btn-text
                                           :answer-color disapprove-btn-color
                                           :model text-val
                                           :buttons-color buttons-color
                                           :action (action-disapprove-btn text-val disapprove-btn-color)}]

                  (disapproved-messages-to-user (if (= @text-val disapprove-btn-text) {:message disapprove-message} ""))]])))
